module.exports = __webpack_public_path__ + "static/media/icon-homepage-memberblock-benefits.4e3ecc91.webp";